// src/utils/exportExcel.js
// 前端本地导出（不依赖后端 / 第三方库）：把表格数据导出为 Excel 可直接打开的 .xls 文件。
// 缺陷 90：导出按钮需真正导出 Excel（原「统计报表」导出仅弹提示、无文件下载）。
const esc = (v) => String(v ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// 展开分组表头（含 children 的列）为叶子列，标题拼接为「父-子」
const flattenCols = (cols, prefix = '') => (cols || []).flatMap((c) => {
  if (c.children && c.children.length) return flattenCols(c.children, c.title);
  return [{ title: prefix ? `${prefix}-${c.title}` : c.title, dataIndex: c.dataIndex }];
});

export const exportTableToExcel = ({ title = 'export', columns = [], rows = [] }) => {
  const leaves = flattenCols(columns);
  const head = leaves.map((c) => `<th>${esc(c.title)}</th>`).join('');
  const body = (rows || []).map((r) => `<tr>${leaves.map((c) => `<td>${esc(r[c.dataIndex])}</td>`).join('')}</tr>`).join('');
  const html = `\uFEFF<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head>`
    + `<body><table border="1"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></body></html>`;
  const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title}_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
